<template>
  <div class="mx-3">
    <v-row>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="4"          
        md="12"
        sm="12"
        xl="3"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in version or year here"
          append-icon="search"
          label="Search version or year"
          hide-no-data
          hide-selected
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="typeOfMisconductRevisions"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.version="{ item }">
        {{ versionStarter + item.version }}
      </template>

      <template v-slot:item.start_date="{ item }">
        {{ $moment(item.start_date).format('DD MMM YYYY') }}
      </template>

      <template v-slot:item.end_date="{ item }">
        {{ item.end_date ? $moment(item.end_date).format('DD MMM YYYY') : 'N/A' }}
      </template>
    
      <template v-slot:item.action="{ item }">
        <span>
          <setup-discipline-type-of-misconduct-revision-dialog-edit
            v-if="$hasPermissionTo(['update type of misconduct revisions'])"
            :type-of-misconduct-revision="item"
            @updated="loadData(); loadTypeOfMisconductVersionFilter()"
          />
        </span>
      </template> 
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupDisciplineTypeOfMisconductRevisionDialogEdit: () => import('@/components/hris/setup/disciplines/type-of-misconduct/revision/DialogEdit'),
    },
    data () {
      return {
        headers: [
          {
            text: 'Version',
            align: 'left',
            value: 'version',
          },
          {
            text: 'Start Date',
            align: 'left',
            value: 'start_date',
            sortable: false,
          },
          {
            text: 'End Date',
            align: 'left',
            value: 'end_date',
            sortable: false,
          },
          {
            text: '',
            sortable: false,
            value: 'action',
            width: '120',
          },
        ],
        search: '',
        versionStarter: '',
        tableLoading: false,
        typeOfMisconductRevisions: [],
      }
    },
    mounted () {
      this.loadSystemSettings()
      this.loadData()
    },
    methods: {
      loadSystemSettings () {
        this.$api.systemSettings().list()
          .then((res) => {
            this.versionStarter = res.data.find(setting => setting.key === 'VERSION_STARTER').value
          })
          .catch(() => {})
      },
      loadData () {
        this.tableLoading = true

        this.$api.typeOfMisconductRevisions().list()
          .then(res => {
            this.typeOfMisconductRevisions = _.orderBy(res.data, ['version'], ['desc'])
            this.tableLoading = false
          })
      },
      loadTypeOfMisconductVersionFilter () {
        if (this.$hasPermissionTo(['view type of misconducts'])) {
          this.$emit('reloadVersion')
        }
      },
    },
  }
</script>
